import { t } from "../../i18n";
import type { WallInput } from "@tasduvar/engine";
import { useFullAccess } from "../../billing/access";
import { useCadUi } from "../../state/cadUiStore";
import { resizeKind, startResize, useResizeRunning } from "../design/resize";
import { openWizard } from "../../state/wizardStore";

/**
 * Sağlanmayan kontrol varken yol gösterme (Cem 2026-10-06: "Programımız yönlendirsin doğru yola"): elle çizilen / düzenlenen
 * duvarda kurtaran boyutu program bulsun — Akıllı tasarım paftası (taş + betonarme karşılaştırması) ya da duvarın kendi
 * tipinde "Yeniden boyutlandır" (parametrik taş / payandasız konsol; çokgen ve payandalıda yok).
 */
export function FixActions({ wall }: { wall: WallInput }): JSX.Element {
  const full = useFullAccess(), resizing = useResizeRunning();
  const kind = resizeKind(wall);
  const toDesign = (): void => {
    const cad = useCadUi.getState();
    if (cad.ribbonTab === "quantities" || cad.ribbonTab === "report" || cad.ribbonTab === "drawing") cad.setRibbonTab("home");
    cad.setLayout("design");
  };
  return (
    <div role="group" aria-label={t("Sağlamayan duvar için öneri")} className="flex flex-wrap items-center gap-1 border border-cad-line bg-[#FFF8E6] px-2 py-1">
      <span className="w-full text-[10px] text-cad-ink2">{t("Kurtaran boyutu program bulsun:")}</span>
      <button type="button" className="cad-btn-primary whitespace-nowrap" onClick={toDesign}>✨ {t("Akıllı tasarımla boyutlandır")}</button>
      <button type="button" className="cad-btn-box whitespace-nowrap" title={t("Zemin raporu, zemin türü, drenaj ve yeraltı suyunu adım adım gözden geçir")} onClick={() => openWizard(wall.id)}>📄 {t("Sihirbaz")}</button>
      {kind && full ? <button type="button" className="cad-btn-box whitespace-nowrap" disabled={resizing} title={t("Duvarın kendi tipinde en ucuz kurtaran kesiti bul ve uygula")} onClick={() => startResize(wall)}>{resizing ? t("Hesaplanıyor…") : t("Yeniden boyutlandır")}</button> : null}
    </div>
  );
}
